<!-- <layout-block-list-outlet [attr.aria-label]="page?.layoutLabel"
                          [list]="page?.prelayout"></layout-block-list-outlet> -->
<!-- Lav breadcrum som dynamisk element der indsættes via umbraco -->

<!-- Tag filter ind her -->
<layout-block-list-outlet [attr.aria-label]="page?.layoutLabel"
                          [list]="page?.layout"></layout-block-list-outlet>
<!-- <div class="grid">
    <a [routerLink]="article?.url"
       *ngFor="let article of page?.articles">
       @if(article?.media != null) {
        <img [use]="article?.media"
             [query]="{ width: 730, height:730, rmode:'crop', rxy:'0.5,0.5' }">
        }@else {
            <svg width="730"
                    height="590"
                    role="presentation">
                <rect width="730" height="590" fill="currentColor" />
                </svg>
            }
        <time [attr.datetime]="article?.updated | date:'MMM d, y'">{{ article?.updated | date:'MMM d, y' }}</time>
         <span class="tag">{{ article?.text }}</span>
        @if(article?.title != null && article?.title !== '') {
            <span class="title">{{ article?.title }}</span>
        }
        @else if(article?.pageTitle != null && article?.pageTitle !== '') {
            <span class="title">{{ article?.pageTitle }}</span>
        }
        @else {
            <span class="title">&nbsp;</span>
        }
    </a>
</div> -->
